<script lang="ts" setup>
	export type FAQContext = {
		question: string
		answer: string
		open: boolean
	}

	defineProps<{
		faqList: FAQContext[]
	}>()
</script>

<template>
	<section>
		<div class="lg:flex items-start` justify-between flex-wrap gap-x-5 space-y-10">
			<div class="space-y-4 max-w-[420px] w-full md:pb-0 pb-8">
				<h3
					class="text-blue-950 dark:text-gray-300 -tracking-[0.08rem] md:-tracking-[0.1rem] lg:-tracking-[0.13rem] lg:text-[3.25rem]/[4.55rem] md:text-[2.625rem]/[3.15rem] text-[2rem]/[2.4rem] maitree-bold"
				>
					Frequently asked questions
				</h3>
				<p class="lg:text-xl md:text-lg text-base text-gray-600 dark:text-gray-400">
					We've answered some important insurance questions here
				</p>
			</div>

			<ul id="question" class="flex-1 max-w-[790px] w-full">
				<li
					v-for="(item, index) in faqList"
					:key="index"
					class="sm:py-8 py-4 border-t border-gray-300 dark:border-gray-600"
					:aria-label="`${index + 1} of ${faqList.length}`"
				>
					<button
						type="button"
						class="flex items-center gap-x-4 justify-between w-full text-left custom-transition-2"
						:aria-controls="`menu-${index + 1}`"
						:aria-expanded="item.open"
						@click="() => (item.open = !item.open)"
					>
						<span class="font-medium text-base md:text-lg lg:text-xl text-gray-800 dark:text-gray-500">
							{{ item.question ?? 'N/A' }}
						</span>
						<span :class="['custom-transition-2', item.open ? 'rotate-45' : '']">
							<tools-icon dir="line" icon="crosshair" svg="h-[18px] md:h-[24px]" />
						</span>
					</button>

					<div
						:class="['pr-4 custom-transition-3 overflow-hidden', item.open ? 'max-h-[1000px]' : 'max-h-0']"
						:id="`menu-${index + 1}`"
					>
						<p class="sm:text-base text-sm text-gray-600 pt-3">
							<client-only>
								<span v-html="item.answer" />
							</client-only>
						</p>
					</div>
				</li>
			</ul>
		</div>
	</section>
</template>
